/**
 * 远程控制页面顶栏。
 */

/**
 * 渲染空白占位的顶部导航条。
 */
const Navbar = () => {
	return (
		<div className="container max-w-full wrapper bg-primary shadow-sm">
			<div className="flex space-between px-4 py-2 text-slate-50">
				<div>
					{/* <img alt="" className="logo" src={dten_logo} /> */}
					{/* <a href="//www.easyremote.link" className="text-lg title logo">
            Easy Remote
          </a> */}
					<div className="min-h-[35px]"></div>
				</div>
				<div>
					<div style={{ marginRight: "10px" }}></div>
					<div>
						{/* <Link to="/login">
              <Button variant="light" size="sm">
                Docs
              </Button>
            </Link> */}
					</div>
					{/* <div style={{ marginRight: "10px" }}>{user}</div> */}
				</div>
			</div>
		</div>
	);
};

export default Navbar;
